module.exports = __webpack_public_path__ + "img/media_de_compras_por_cliente.42f258e8.png";